import type { ApiModuleEndpoints } from '../types'

export const cashBookApiEndpoints = {
  types: {
    method: 'GET',
    path: '/cash-book/types',
    requiresAuth: true,
  },
  typeOptions: {
    method: 'GET',
    path: '/cash-book/types/options',
    requiresAuth: true,
  },
  createType: {
    method: 'POST',
    path: '/cash-book/types',
    requiresAuth: true,
  },
  updateType: {
    method: 'PUT',
    path: '/cash-book/types/:id',
    requiresAuth: true,
  },
  deleteType: {
    method: 'DELETE',
    path: '/cash-book/types/:id',
    requiresAuth: true,
  },
  entries: {
    method: 'GET',
    path: '/cash-book/entries',
    requiresAuth: true,
  },
  entryDetail: {
    method: 'GET',
    path: '/cash-book/entries/:id',
    requiresAuth: true,
  },
  createEntry: {
    method: 'POST',
    path: '/cash-book/entries',
    requiresAuth: true,
  },
  cancelEntry: {
    method: 'POST',
    path: '/cash-book/entries/:id/cancel',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
